import React, { Component } from "react";
import clsx from "clsx";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import {
  CssBaseline,
  CircularProgress,
  Container,
  Button,
  Grid,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";
import Api from "../../services/api";
import MyMaterialTable from "../../components/table";
import { Can } from "../../config/ability-context";
import { AbilityContext } from "../../config/ability-context";
import * as componentActions from "../../redux/actions/templatemessages";
import Footer from "../../components/footer";
import { FormattedMessage, injectIntl } from "react-intl";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import Search from "@mui/icons-material/Search";
import TextField from "@mui/material/TextField";
import ClearIcon from "@mui/icons-material/Clear";
import Api2Talk from "src/services/api2talk";
import SimpleSelect from "../../components/select/simple-search";
import SimpleAutoComplete from "../../components/auto-complete/autocomplete";

class TemplateMessage extends Component {
  constructor(props) {
    super(props);

    this.typingTimeout = null;
    const { userSession } = this.props;

    const intl = this.props.intl;

    let filters = [
      {
        name: intl.formatMessage({ id: "name" }),
        id: "name",
      },
      {
        name: intl.formatMessage({ id: "organization.phoneNumber" }),
        id: "phone",
      },
      {
        name: intl.formatMessage({ id: "provider" }),
        id: "provider",
      },
    ];

    this.state = {
      loading: false,
      openNotification: false,
      notificationVariant: "error",
      notificationMessage: "",
      resultList: [],
      totalPages: 0,
      page: 1,
      pageStart: 0,
      pageEnd: 0,
      count: 0,
      searchValue: "",
      filters,
      filterSelected: 0,
      listFilterSelected: [],
      filterSelectedData: { id: 0, name: "" },
      templateTypeList: [],
    };

    this.callSearch = this.callSearch.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.closeNotification = this.closeNotification.bind(this);
    this.deleteItem = this.deleteItem.bind(this);
    this.clearFields = this.clearFields.bind(this);
  }

  onChangePaginate = (e, page) => {
    this.setState({ page: page });
    this.getItens(page);
  };

  setPagination(count, page) {
    let totalPage = Math.ceil(count / 10);
    this.setState({ totalPages: totalPage });
    if (count > 0) {
      if (page == 1) {
        if (count < 10) {
          this.setState({ pageStart: 1, pageEnd: count });
        } else {
          this.setState({ pageStart: 1, pageEnd: 10 });
        }
      } else {
        let pageStart = (page - 1) * 10 + 1;

        if (count >= page * 10) {
          this.setState({ pageStart: pageStart, pageEnd: page * 10 });
        } else {
          this.setState({ pageStart: pageStart, pageEnd: count });
        }
      }
    } else {
      this.setState({ totalPages: 0, page: 1, count: 0 });
    }
  }

  onFieldChange(event) {
    this.setState({ [event.target.name]: event.target.value, page: 1 });
  }

  uniqueById(array) {
    const seen = new Set();
    return array.filter((item) => {
      const duplicate = seen.has(item.id);
      seen.add(item.id);
      return !duplicate;
    });
  }

  filter(field) {
    const actualList = this.state.resultList;

    switch (field) {
      case "phone":
        return this.uniqueById(
          actualList.map((item) => {
            return {
              name: item.phone_number,
              id: item.registrationnumberrequestid,
            };
          })
        );

      case "provider":
        return this.uniqueById(
          actualList.map((item) => {
            return {
              name: item.provider,
              id: item.messageproviderid,
            };
          })
        );

      default:
        return [];
    }
  }

  callSearch() {
    const filterSelected = this.state.filterSelected;

    const nameCondition =
      filterSelected == "name" && this.state.searchValue != "";
    const otherCondition =
      filterSelected != 0 && this.state.filterSelectedData.name != "";

    if (filterSelected != 0 && (nameCondition || otherCondition)) {
      this.getItens(this.state.page);
    }
  }

  async clearFields() {
    await this.setState({
      page: 1,
      searchValue: "",
      filterSelected: 0,
      listFilterSelected: [],
      filterSelectedData: { id: 0, name: "" },
    });

    this.getItens(1);
  }

  getApiErrorMessage(source, fallbackMessage) {
    const errorMessage =
      source?.data?.errors?.[0] ||
      source?.data?.response?.data?.errors?.[0] ||
      source?.response?.data?.errors?.[0] ||
      source?.response?.data?.response?.data?.errors?.[0];

    return this.formatMetaErrorMessage(errorMessage, fallbackMessage);
  }

  formatMetaErrorMessage(errorMessage, fallbackMessage) {
    if (!errorMessage) {
      return fallbackMessage;
    }

    if (typeof errorMessage !== "string") {
      return fallbackMessage;
    }

    try {
      const parsedError = JSON.parse(errorMessage);
      if (parsedError && parsedError.error) {
        return this.buildMetaErrorMessage(parsedError.error);
      }
    } catch {
      return errorMessage;
    }

    return errorMessage;
  }

  buildMetaErrorMessage(metaError) {
    const labels = {
      message: "Mensagem",
      type: "Tipo",
      code: "Código",
      error_subcode: "Subcódigo",
      is_transient: "Transiente",
      error_user_title: "Título",
      error_user_msg: "Detalhe",
      fbtrace_id: "Trace",
    };

    const lines = ["Erro retornado pela Meta."];
    Object.keys(labels).forEach((key) => {
      if (metaError[key] !== undefined && metaError[key] !== null && metaError[key] !== "") {
        const value = key === "is_transient" ? this.formatBooleanText(metaError[key]) : metaError[key];
        lines.push(`${labels[key]}: ${value}`);
      }
    });

    Object.keys(metaError).forEach((key) => {
      if (!labels[key] && metaError[key] !== undefined && metaError[key] !== null && metaError[key] !== "") {
        lines.push(`${key}: ${typeof metaError[key] === "object" ? JSON.stringify(metaError[key]) : metaError[key]}`);
      }
    });

    return lines.join("\n");
  }

  formatBooleanText(value) {
    if (value === true || value === "true") {
      return "Sim";
    }

    if (value === false || value === "false") {
      return "Não";
    }

    return value;
  }

  deleteItem(data, resolve) {
    Api2Talk.delete(`/templatemessage/${data.id}`)
      .then((result) => {
        if (result.data.success) {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "success",
            notificationMessage: intl.formatMessage({ id: "delete.sucess" }),
            resultList: [],
          });

          this.getItens();
        } else {
          const intl = this.props.intl;
          const notificationMessage = this.getApiErrorMessage(result, intl.formatMessage({ id: "process.error" }));
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage: notificationMessage,
          });
          Api.kickoff(result);
        }
        resolve();
      })
      .catch((err) => {
        resolve();
        const intl = this.props.intl;
        const notificationMessage = this.getApiErrorMessage(err, intl.formatMessage({ id: "process.error" }));
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage: notificationMessage,
        });
        Api.kickoff(err);
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.state === "reload") {
      this.componentDidMount();
    }
  }

  async componentDidMount() {
    const templateTypeList = await this.fetchTemplateTypes();
    this.getItens(1, templateTypeList);
  }

  fetchTemplateTypes = async () => {
    this.setState({ loading: true });

    try {
      const result = await Api2Talk.get(`/templatemessage/template-types`);
      this.setState({ loading: false });

      if (result.data.success) {
        const templateTypeList = result.data.data || [];
        this.setState({ templateTypeList });
        return templateTypeList;
      }

      const intl = this.props.intl;
      this.setState({
        openNotification: true,
        notificationVariant: "error",
        notificationMessage:
          result.data &&
          result.data.response &&
          result.data.response.data &&
          result.data.response.data.errors &&
          result.data.response.data.errors[0]
            ? result.data.response.data.errors[0]
            : intl.formatMessage({ id: "process.error" }),
      });
      Api.kickoff(result);
      return [];
    } catch (err) {
      const intl = this.props.intl;
      this.setState({
        loading: false,
        openNotification: true,
        notificationVariant: "error",
        notificationMessage:
          err.response &&
          err.response.data &&
          err.response.data.errors &&
          err.response.data.errors[0]
            ? err.response.data.errors[0]
            : intl.formatMessage({ id: "process.error" }),
      });
      Api.kickoff(err);
      return [];
    }
  };

  getTemplateTypeName(templateType, templateTypeList = this.state.templateTypeList) {
    if (templateType != null && typeof templateType === "object") {
      return templateType.name || "";
    }

    const selectedTemplateType = templateTypeList.find(
      (item) => item.id == templateType
    );

    return selectedTemplateType ? selectedTemplateType.name : "";
  }

  getMetaCategoryName(metaCategory) {
    const category = (metaCategory || "UTILITY").toUpperCase();
    const translationKeys = {
      MARKETING: "template.meta.category.marketing",
      UTILITY: "template.meta.category.utility",
      AUTHENTICATION: "template.meta.category.authentication",
    };
    return translationKeys[category]
      ? this.props.intl.formatMessage({ id: translationKeys[category] })
      : category;
  }

  handlerParameter = (page) => {
    let url = `/templatemessage/paginate?page=${page}`;

    const filterSelected = this.state.filterSelected;
    const hasFilterSelected = filterSelected != 0;
    const isNameFilter = filterSelected == "name";

    const searchValue = this.state.searchValue;
    const filterSelectedData = this.state.filterSelectedData;

    if (hasFilterSelected && isNameFilter && searchValue != "") {
      url += `&field=${filterSelected}&search=${searchValue}`;
    }

    if (hasFilterSelected && !isNameFilter && filterSelectedData.name != "") {
      url += `&field=${filterSelected}&search=${filterSelectedData.id}`;
    }

    return url;
  };

  getItens(page = 1, templateTypeList = this.state.templateTypeList) {
    this.setState({ loading: true });
    let url = this.handlerParameter(page);

    Api2Talk.get(url)
      .then((result) => {
        if (result.data.success) {
          let count = result.data.count;
          this.setState({ count: count });
          this.setPagination(count, page);
          const formattedList = result.data.data.map((item) => {
            return {
              ...item,
              type:
                item.templatetypename ||
                this.getTemplateTypeName(item.templatetype, templateTypeList),
              metaCategory: this.getMetaCategoryName(item.metacategory),
              provider: item.messageprovider.name,
              phone_number: item.registrationnumberrequest.phonenumber,
              createdBySystem: item.system
                ? this.props.intl.formatMessage({ id: "yes" })
                : this.props.intl.formatMessage({ id: "no" }),
            };
          });
          this.setState({ loading: false, resultList: formattedList });
        } else {
          const intl = this.props.intl;
          this.setState({
            loading: false,
            openNotification: true,
            notificationVariant: "error",
            notificationMessage:
              result.data &&
              result.data.response &&
              result.data.response.data &&
              result.data.response.data.errors &&
              result.data.response.data.errors[0]
                ? result.data.response.data.errors[0]
                : intl.formatMessage({ id: "process.error" }),
          });
          Api.kickoff(result);
        }
      })
      .catch((err) => {
        const intl = this.props.intl;
        this.setState({
          loading: false,
          openNotification: true,
          notificationVariant: "error",
          notificationMessage:
            err.response &&
            err.response.data &&
            err.response.data.errors &&
            err.response.data.errors[0]
              ? err.response.data.errors[0]
              : intl.formatMessage({ id: "process.error" }),
        });
        Api.kickoff(err);
      });
  }

  closeNotification() {
    this.setState({ openNotification: false });
  }

  renderDynamicComboBox(intl) {
    const filterSelected = this.state.filterSelected;

    if (filterSelected == 0) return <></>;

    if (filterSelected == "name") {
      return (
        <TextField
          type="text"
          name="searchValue"
          fullWidth
          label={intl.formatMessage({ id: "search" })}
          placeholder={intl.formatMessage({
            id: "templates",
          })}
          value={this.state.searchValue}
          onChange={this.onFieldChange}
        />
      );
    }

    return (
      <SimpleAutoComplete
        label={intl.formatMessage({ id: "label.listing" })}
        options={this.state.listFilterSelected}
        disabled={this.state.listFilterSelected.length == 0}
        stateName="listFilterSelectedId"
        selected={this.state.filterSelectedData}
        changeSelect={(stateName, value) => {
          this.setState({
            filterSelectedData: value,
          });
        }}
      />
    );
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu } = this.props;
    const intl = this.props.intl;

    if (Api == null) {
      var l = this.props.match.params.lang;
      document.location.href = `/${l}/unavailable`;
    }

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main
          className={clsx(
            classes.content,
            {
              [classes.contentShift]: headerMenu.open,
            },
            classes.actionsContent,
            {
              [classes.actionscontentShift]: actionsHeaderMenu.open,
            }
          )}
        >
          <div className={classes.drawerHeader} />

          <Container
            component="main"
            maxWidth="xl"
            style={{ maxWidth: "100%", paddingLeft: 0, marginLeft: 0 }}
          >
            <CssBaseline />
            <Grid container className={classes.mb20} spacing={0}>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                disabled={!this.context.can("Add", "Segment")}
                className={classes.button}
                startIcon={<AddIcon />}
                component={Link}
                {...{
                  to: `/${this.props.match.params.lang}/template-message-registration`,
                }}
              >
                {<FormattedMessage id="add" />}
              </Button>
            </Grid>
            <Grid container spacing={6}>
              <Grid item xs={12} sm={12}>
                <Card className="background-title-search">
                  <CardContent>
                    <Grid container spacing={1} alignItems="center" mt={2}>
                      <Grid item xs={5.2} sm={5.2} md={5.2} lg={5.2}>
                        <Typography variant="h5">
                          {<FormattedMessage id="templates" />}
                        </Typography>
                      </Grid>

                      <Grid
                        container
                        xs={6}
                        sm={6}
                        md={6}
                        lg={6}
                        spacing={2}
                        justifyContent={"flex-end"}
                      >
                        <Grid
                          item
                          xs={12} md={4}
                        >
                          <SimpleSelect
                            label={intl.formatMessage({
                              id: "field",
                            })}
                            customLabelSearch={intl.formatMessage({
                              id: "label.search.simple",
                            })}
                            options={this.state.filters}
                            stateName="filter"
                            changeSelect={(stateName, value) => {
                              const listFilterSelected = this.filter(value);

                              this.setState({
                                filterSelected: value,
                                listFilterSelected,
                                filterSelectedData: { id: 0, name: "" },
                              });
                            }}
                            selected={this.state.filterSelected}
                          />
                        </Grid>

                        {this.state.filterSelected != 0 && (
                          <Grid item xs={12} md={4}>
                            {this.renderDynamicComboBox(intl)}
                          </Grid>
                        )}

                        <Grid
                          item
                          alignContent={"center"}
                        >
                          <Button
                            variant="contained"
                            color="secondary"
                            size="large"
                            onClick={this.callSearch}
                            className={classes.button}
                          >
                            <Search />
                          </Button>
                        </Grid>

                        <Grid
                          item
                          alignContent={"center"}
                        >
                          <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            onClick={this.clearFields}
                            className={classes.button}
                          >
                            <ClearIcon />
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Can I="List" a="Segment">
              <MyMaterialTable
                title=""
                rowClick={(event, rowData) => {
                  let abl = this.context.can("Edit", "Segment");
                  if (abl == false) {
                    this.setState({
                      loading: false,
                      openNotification: true,
                      notificationVariant: "error",
                      notificationMessage: intl.formatMessage({
                        id: "operation.notAllowed",
                      }),
                    });
                    return false;
                  }

                  this.props.addCurrent(rowData);
                  this.props.history.push(
                    `/${this.props.match.params.lang}/template-message-edit`
                  );
                }}
                columns={[
                  { title: intl.formatMessage({ id: "id" }), field: "id" },
                  { title: intl.formatMessage({ id: "name" }), field: "name" },
                  { title: intl.formatMessage({ id: "type" }), field: "type" },
                  { title: intl.formatMessage({ id: "template.meta.category" }), field: "metaCategory" },
                  {
                    title: intl.formatMessage({ id: "status" }),
                    field: "status",
                  },
                  {
                    title: intl.formatMessage({ id: "phone" }),
                    field: "phone_number",
                  },
                  {
                    title: intl.formatMessage({ id: "provider" }),
                    field: "provider",
                  },
                  {
                    title: intl.formatMessage({ id: "created.by.the.system" }),
                    field: "createdBySystem",
                  },
                ]}
                data={this.state.resultList}
                deleteItem={this.deleteItem}
              />
            </Can>

            <Can I="List" a="Segment">
              <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                  <Pagination
                    count={this.state.totalPages}
                    page={this.state.page}
                    onChange={this.onChangePaginate}
                  />
                </Grid>
                <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                  {this.state.pageStart} {<FormattedMessage id="to" />}{" "}
                  {this.state.pageEnd} {<FormattedMessage id="of" />}{" "}
                  {this.state.count} {<FormattedMessage id="register" />}
                </Grid>
              </Grid>
            </Can>

            {this.state.loading && (
              <Overlay>
                <CircularProgress color="secondary" />
              </Overlay>
            )}

            <CustomizedSnackbars
              variant={this.state.notificationVariant}
              message={this.state.notificationMessage}
              isOpen={this.state.openNotification}
              toClose={this.closeNotification}
            />
          </Container>
        </main>
        <Footer />
      </div>
    );
  }
}
TemplateMessage.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
  templatemessages: state.templatemessages,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(componentActions, dispatch);
export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(Styles)(TemplateMessage))
);

TemplateMessage.contextType = AbilityContext;
